import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-2v1',
  templateUrl: './2v1.component.html',
})
export class VbGeneral2v1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
